import { $Q, $Qll } from 'graditify-utils';

/**
 * web component for card product.
 * manage the variant change and add to cart events from here.
 * event delegation is used, this way we avoid having to reload the events once a reload is done by section rendering.
 */
class CardProduct extends HTMLElement {
  constructor() {
    super();

    this.colors = $Qll('.color-js', this);
    this.image = $Q('.product-image-js', this);
    this.clonned = false;
  }

  connectedCallback() {
    this.colors.forEach((option) => {
      option.addEventListener('mouseover', (e) => this.onHoverOption(e.target));
      option.addEventListener('focus', (e) => this.onHoverOption(e.target));
    });
    const node = this.cloneNode(true);
    const cloned = this.getAttribute('data-cloned');
    if (cloned == 'false' && window.innerWidth >= 768) {
      this.addEventListener('mouseover', () => {
        this.setAttribute('data-cloned', true);
        node.setAttribute('data-cloned', true);
        node.classList.add('product-card--cloned');
        this.cloneElement(node);
      });
      this.addEventListener('focus', () => {
        this.setAttribute('data-cloned', true);
        node.setAttribute('data-cloned', true);
        node.classList.add('product-card--cloned');
        this.cloneElement(node);
      });
    }
    this.addEventListener('mouseleave', () => {
      const nodeCloned = this.querySelector('[data-cloned="true"]');
      if (nodeCloned) {
        nodeCloned.remove();
      }
    });
  }

  cloneElement(node) {
    this.appendChild(node);
  }

  onHoverOption(target) {
    const imageUrl = target.dataset.image;
    this.image.setAttribute('src', imageUrl);
    this.image.setAttribute('srcset', imageUrl);
  }
}

export default CardProduct;
